jQuery(document).ready(function($) {

    var has_logger = !!(window.console && window.console.log);

    $.ajaxSetup({traditional: true});
    $('body').addClass('js-enabled').ajaxStart(function() {
        $(this).addClass('ajax-loading');
    }).ajaxStop(function() {
        $(this).removeClass('ajax-loading');
    });

    // Email link generation
    $('span.mailto').each(function(){
        exp = $(this).text().search(/\((.*?)\)/) != -1 ? new RegExp(/(.*?) \((.*?)\)/) : new RegExp(/.*/);
        match = exp.exec($(this).text());
        addr = match[1] ? match[1].replace(/ at /,'@').replace(/ dot /g,'.') : match[0].replace(/ at /,'@').replace(/ dot /g,'.');
        emaillink = match[2] ? match[2] : addr;
        subject = $(this).attr('title') ? '?subject='+$(this).attr('title').replace(/ /g,'%20') : '';
        $(this).after('<a href="mailto:'+addr+subject+'">'+ emaillink + '</a>');
        $(this).remove();
    });

    // Password reset toggle
    $('.pw-recovery-toggle').click(function() {
        $('.recover-password').addClass('active');
        $('.customer-login').addClass('hidden');
    });
    $('.customer-login-toggle').click(function() {
        $('.recover-password').removeClass('active');
        $('.customer-login').removeClass('hidden');
    });

    // toggle for faq list
    $('.faq-list h2').click(function(){
        $(this).toggleClass('active');
        $(this).next('div').toggleClass('visible');
    });

    // toggle social-buttons
    $('[data-toggle=pop-up]').click(function(){
        $('.account-header__button').toggleClass('active');
        $('.pop-up').toggleClass('visible');
    });

    $(window).click(function(event){
        if( !$(event.target).is('[data-toggle=pop-up]') ) {
          $('.pop-up').removeClass('visible');
        $('.account-header__button').removeClass('active');
        }
    });

    // product slider
    if ( $('.slider').length > 0 ) {

        $('.slider').slick({
            dots: false,
            arrows: false,
            asNavFor: '.slider-nav, .slider-nav-mobile',
            fade: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 900,//this is mobile
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                    }
                }
            ]
        });

        $('.slider-nav').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.slider',
            vertical: true,
            dots: false,
            focusOnSelect: true
        });

        $('.slider-nav-mobile').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.slider',
            dots: false,
            focusOnSelect: true
        });



        // fancybox-enabled

        $(".slider a").fancybox({
            clickContent: false,
            // move the close button inside the image placeholder
            afterLoad : function( instance ) {
              $(instance.$refs.toolbar).appendTo('.fancybox-image-wrap');
              $('.fancybox-button--play, .fancybox-button--fullscreen, .fancybox-button--thumbs').hide();
            },
            mobile: {
              clickOutside : 'close',
            }
        });

    }

    // small check whether search submit validates
    $('button[type=submit]').click( function(e){
        const searchBox = $(this).parent().find('input[type=search]');
        if ( searchBox.val() == '' ) {
            e.preventDefault();
            searchBox.focus();
        }
    })

    // scrollTo reviews on product Page
    $('.smooth')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });

    // Tabs on Product Page
    $('.tabs li:first-child a').addClass('current');

    $('.tabs a').click( function(e) {
        e.preventDefault();
        $('.tabs-content li').removeClass('active');
        $('.tabs a').removeClass('active');
        $(this).addClass('active');

        var activeContentID = $(this).prop('hash');

        $(activeContentID).addClass('active');
    })

    // toggle footer navs
    $('[data-action=toggle]').on( 'click' , function () {
        $(this).parent().toggleClass('open');
    });

    // mobile-nav --primary toggle

    $('[data-action=mobilenav-toggle]').on( 'click' , function(){
        $(this).addClass('active');
        $('.mobile-nav').addClass('open');
        $('<div class="body-overlay"></div>').on("click", function() {
            $('.mobile-nav').removeClass('open');
            $('[data-action=mobilenav-toggle]').removeClass('active');
            $(this).remove();
        }).appendTo($(document.body));
    });

    // mobile-nav --submenu toggle
    $('[data-action=mobilenav-submenu-open]').on( 'click' , function(){
        $(this).next().addClass('open');
    });

    $('[data-action=mobilenav-submenu-close]').on( 'click' , function(){
        $('.mobilenav__menu--submenu').removeClass('open');
    });

    // show recommender
    $('[data-action=show-recommender]').on( 'click', function(){
        $(this).parent().slideUp('fast');
        $('.recommender').slideDown('fast');
    });

    // show/hide the address and new address panels
    var accountDetails = $('.account-details, .add-address-trigger');
    var pageTitle      = $('.page-title');

    $('.add-address-trigger').click(function(){
        pageTitle.text('Add New Address');
        accountDetails.hide();
    });

    $('.activate-edit-address').click(function(){
        var hashTag = $(this).prop('hash');
        $(hashTag).slideDown();
    });

    $('.cancel-add-address').click(function(){
        $('.add-address-form').slideUp();
        accountDetails.show();
        pageTitle.text('Saved Addresses');
    });

    $('.address-edit-toggle').click(function(){
        $(this).parents('.edit-form-wrapper').slideUp();
    });

    // show/hide the revover password form
    $('.pw-recovery-toggle').click(function(){
        $('#login_form').hide();
        $('#recover-password').show();
    });

    // center the impossible figure on the recommender app
    function positionButtonImage() {
        var buttonWidth = $('.recommender__intro--start').width();
        $('.get-slim').css('right', (buttonWidth / 2) - 25 );
    }

    positionButtonImage();

    $(window).resize(function(){
        positionButtonImage();
    });

    // Make links show-off on touch enabled devices
    $('body').bind('touchstart', function() {});

    // Force the capitalization on the input fields
    $('input[type=text]').prop('autocapitalize','sentences');

    // Dropdown on the collection page ...
    $('.list-dropdown').on('click', 'li:first-child a', function(event){
        event.preventDefault();
        $('.list-dropdown').toggleClass('open');
    });

    $(window).click(function(event){
        if(!$(event.target).is('.list-dropdown li a')) {
          $('.list-dropdown').removeClass('open');
        }
    });

    // Update the cart quantity and close the dropdown
    $('.list-dropdown--quantity').on('click', ' li:not(:first-child)', function(event){
        event.preventDefault();
        $('.new-quantity:first-child').remove();
        $(this)
          .addClass('new-quantity')
          .clone()
          .prependTo('.list-dropdown--quantity');

        var newQuantity = $(this).find('a').data('quantity');

        $('#quantity').val(newQuantity);
        $('.list-dropdown--quantity').removeClass('open');
    });


    if ($('body').hasClass('template-collection')) {

        //  and get the query string parameter for sort_by and replace it with the selected text
        var urlParams = window.location.search.substr(1).split('&').reduce(function (q, query) {
          var chunks = query.split('=');
          var key = chunks[0];
          var value = chunks[1];
          return (q[key] = value, q);
        }, {});

        if (urlParams.sort_by != undefined) {
            // Adds .init class to active filter
            $('.list-dropdown.bs-desktop li').each(function(){
                var className = $(this).prop('class');
                if (className == urlParams.sort_by) {
                    $(this).addClass('init');
                    $(this).parent().prepend($(this));
                }
            });

            $('.list-dropdown.bs-mobile li').each(function(){
                var className = $(this).prop('class');
                if (className == urlParams.sort_by) {
                    $(this).addClass('init');
                }
            });

            // Updates .list-dropdown to display active value
            if (urlParams.sort_by.length >=1  ){
                var selectedSearch = $('.init a').html();
                $('.list-dropdown.bs-mobile li:first-child a').html(selectedSearch);
            }
        }

    }

    $('.init a').click(function(event){
        event.preventDefault();
    });

    // show the sms link and the faceboook messenger link when
    // mobile devices

    if (/Mobi/.test(navigator.userAgent)) {
        $('.social-buttons__messenger, .social-buttons__sms').css('display', 'block');
    }

    // Scroll up to the begining of the main review widget
    // on the product page when clicking the pagination links

    $(document).on('click', 'a[data-page]', function(){
        window.scrollTo(0, $(".stamped-tabs").offset().top);
    });

    // Scroll to the begining of the reviews when clicking
    // on the percentage bar in the main review widget

    $(document).on('click', '.stamped-summary .summary-rating-bar', function(){
        window.scrollTo(0, $("#tab-reviews").offset().top);
    });


    // Close the reCharge help popup on the product page
    // toggle social-buttons

    $('.rc_popup__hover').click( function(){
        $('.pop-up--subscription').toggleClass('visible');
    });

    $('.rc_popup__popup--close').click(function(){
        $('.pop-up--subscription').removeClass('visible')
    })

    // Equal height thumbnails (only needed when grid property is not supported)
    // if($('.thumbnail').length > 0) {
    //     $('.thumbnail').matchHeight();
    // }

});
